// extracted by mini-css-extract-plugin
module.exports = {"container":"_1tAyNDMHICybu76PdCvGiq","groupsList":"_24WhlMqQ38gGZ3lxZiZrFf"};